// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/percorso-acquirenti/offerte/:offertaId',
    requestBody: null,
    response: '{"success":true,"data":{"percorso":"object","statoPagina":"string","linkPubblico":"string","modelliDisponibili":"array","logoImpresaUrl":"string","copertinaUrl":"string"}}'
  },
  {
    method: 'PUT',
    endpoint: '/api/percorso-acquirenti/offerte/:offertaId',
    requestBody: '{"attivo":"boolean","scadenzaScelte":"string","testoBenvenuto":"string","modelloId":"number","colorePrincipale":"string","coloreSecondario":"string"}',
    response: '{"success":true,"data":"object"}'
  },
  {
    method: 'POST',
    endpoint: '/api/percorso-acquirenti/offerte/:offertaId/brochure',
    requestBody: '[FormData file]',
    response: '{"success":true,"data":"object"}'
  },
  {
    method: 'POST',
    endpoint: '/api/percorso-acquirenti/offerte/:offertaId/logo-impresa',
    requestBody: '[FormData file]',
    response: '{"success":true,"data":{"percorso":"object","statoPagina":"string","linkPubblico":"string","logoImpresaUrl":"string","copertinaUrl":"string"}}'
  },
  {
    method: 'POST',
    endpoint: '/api/percorso-acquirenti/offerte/:offertaId/copertina',
    requestBody: '[FormData file]',
    response: '{"success":true,"data":{"percorso":"object","statoPagina":"string","linkPubblico":"string","logoImpresaUrl":"string","copertinaUrl":"string"}}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/percorso-acquirenti/offerte/:offertaId/logo-impresa',
    requestBody: null,
    response: '{"success":true,"data":{"percorso":"object","statoPagina":"string","linkPubblico":"string","logoImpresaUrl":"string","copertinaUrl":"string"}}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/percorso-acquirenti/offerte/:offertaId/copertina',
    requestBody: null,
    response: '{"success":true,"data":{"percorso":"object","statoPagina":"string","linkPubblico":"string","logoImpresaUrl":"string","copertinaUrl":"string"}}'
  },
  {
    method: 'GET',
    endpoint: '/api/percorso-acquirenti/offerte/:offertaId/brochure',
    requestBody: null,
    response: 'file PDF (inline)'
  },
  {
    method: 'GET',
    endpoint: '/api/percorso-acquirenti/offerte/:offertaId/qr',
    requestBody: null,
    response: 'file PNG (attachment)'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
